import React, { useState } from 'react';

/**
 * Single image thumbnail with React-based error state (no innerHTML).
 * Accessible: min touch target, alt, loading state.
 */
function ImageThumbnail({ image, index, onOpenModal }) {
  const [loadFailed, setLoadFailed] = useState(false);
  const src = image.url || image.signedUrl;
  const alt = image.filename ? `Zdjęcie ${index + 1}: ${image.filename}` : `Zdjęcie ${index + 1}`;

  const handleError = () => {
    setLoadFailed(true);
  };

  if (loadFailed) {
    return (
      <div
        className="w-full h-48 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center"
        role="img"
        aria-label="Błąd ładowania zdjęcia"
      >
        <span className="text-gray-400 text-sm">Błąd ładowania</span>
      </div>
    );
  }

  return (
    <div className="relative group">
      <img
        src={src}
        alt={alt}
        className="w-full h-48 object-cover rounded-lg border border-gray-200 cursor-pointer hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        onClick={() => onOpenModal(image, index)}
        onError={handleError}
        loading="lazy"
      />
      <div
        className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity rounded-lg flex items-center justify-center pointer-events-none"
        aria-hidden
      >
        <span className="text-white opacity-0 group-hover:opacity-100 text-sm">
          Kliknij aby powiększyć
        </span>
      </div>
      {image.filename && (
        <p
          className="text-xs text-gray-500 mt-1 truncate"
          title={image.filename}
        >
          {image.filename}
        </p>
      )}
    </div>
  );
}

export default ImageThumbnail;
